import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess304003Status: 'idle',
    startProcess304003Error: undefined as any,
    loadUserParamsProcess304003Status: 'idle',
    loadUserParamsProcess304003Error: undefined as any,

    process304003List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess304003 = createAsyncThunk('process304003Slice/startProcess304003', async ({ process304003 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess304003/`,
        prepareData(process304003),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess304003Status } = getState().process304003Slice
        return startProcess304003Status !== 'pending'
    }
})

export const loadUserParamsProcess304003 = createAsyncThunk('process304003Slice/loadUserParamsProcess304003', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess304003/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess304003Status } = getState().process304003Slice
        return loadUserParamsProcess304003Status !== 'pending'
    }
})

const Process304003Slice = createSlice({
    name: 'process304003Slice',
    initialState,
    reducers: {
        resetstartProcess304003: (state) => {
            state.job = undefined
            state.startProcess304003Error = undefined
        },
        resetstartProcess304003Error: (state) => {
            state.startProcess304003Error = undefined
        },
        resetloadUserParamsProcess304003: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess304003Error = undefined
        },
        resetloadUserParamsProcess304003Error: (state) => {
            state.loadUserParamsProcess304003Error = undefined
        },
        removeFromProcess304003ListById: (state, action) => {
            state.process304003List = state.process304003List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess304003ListByIds: (state, action) => {
            state.process304003List = state.process304003List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process304003List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess304003Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process304003List = []
            state.startProcess304003Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess304003.pending, (state) => {
            state.startProcess304003Status = 'pending'
            state.startProcess304003Error = undefined
        })
        builder.addCase(startProcess304003.fulfilled, (state, action) => {
            state.startProcess304003Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess304003.rejected, (state, action) => {
            state.startProcess304003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess304003Error = action.error.message
            } else {
                state.startProcess304003Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess304003.pending, (state) => {
            state.loadUserParamsProcess304003Status = 'pending'
            state.loadUserParamsProcess304003Error = undefined
        })
        builder.addCase(loadUserParamsProcess304003.fulfilled, (state, action) => {
            state.loadUserParamsProcess304003Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess304003.rejected, (state, action) => {
            state.loadUserParamsProcess304003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess304003Error = action.error.message
            } else {
                state.loadUserParamsProcess304003Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess304003,
    resetstartProcess304003Error,
    resetloadUserParamsProcess304003,
    resetloadUserParamsProcess304003Error,
    removeFromProcess304003ListById,
    removeFromProcess304003ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process304003Slice.actions
export default Process304003Slice.reducer
